// @flow

import { graphql } from 'react-relay';
import { ConnectionHandler } from 'relay-runtime';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation AddVendorItemPriceMutation($input: AddVendorItemPriceInput!) {
    addVendorItemPrice(input: $input) {
      vendorItemPriceEdge {
        node {
          id
          vendor {
            id
          }
          item {
            id
            name
          }
          unitPrice
          leadTimeDays
          isPreferred
          createdAt
        }
      }
    }
  }
`;

export default {
  commit: (options: *) => {
    return createRelayMutation(mutation, {
      ...options,
      updater: (store) => {
        const payload = store.getRootField('addVendorItemPrice');
        const newEdge = payload.getLinkedRecord('vendorItemPriceEdge');
        const vendorNode = newEdge.getLinkedRecord('node').getLinkedRecord('vendor');
        const vendorId = vendorNode.getValue('id');
        
        // Get the vendor record from the store
        const vendor = store.get(vendorId);
        if (vendor) {
          // Get existing itemPrices record
          const itemPrices = vendor.getLinkedRecord('itemPrices');
          
          if (itemPrices) {
            // Get existing edges
            const edges = itemPrices.getLinkedRecords('edges') || [];
            
            // Add new edge to the array
            const updatedEdges = [...edges, newEdge];
            
            // Update the edges array
            itemPrices.setLinkedRecords(updatedEdges, 'edges');
          }
        }
      },
    });
  },
};
